/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_TargetInputs */

const en_fw_notify_target = /** @type {(inputs: Fw_Notify_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const id_fw_notify_target = /** @type {(inputs: Fw_Notify_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Fw_Notify_TargetInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_target = /** @type {((inputs?: Fw_Notify_TargetInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_TargetInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_target(inputs)
	return en_fw_notify_target(inputs)
});